import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";

const filterBookingsByTimeframe = (bookings, value) => {
  const now = moment(); // Current date and time

  if (value === "Today") {
    return bookings.filter((booking) => moment(booking.createdAt).isSame(now, "day"));
  } else if (value === "Last 7 days") {
    return bookings.filter((booking) =>
      moment(booking.createdAt).isAfter(now.clone().subtract(7, "days"))
    );
  } else if (value === "Last 30 days") {
    return bookings.filter((booking) =>
      moment(booking.createdAt).isAfter(now.clone().subtract(30, "days"))
    );
  }
  return bookings; // "Overall" case - return all bookings
};

const getBookingChartData = (bookings, value) => {
  const now = moment();
  let categories = [];
  let seriesData = [];

  if (value === "Overall") {
    const uniqueMonths = Array.from(
      new Set(bookings.map((booking) => moment(booking.createdAt).format("MMM YYYY")))
    );

    categories = uniqueMonths;
    seriesData = uniqueMonths.map(
      (month) =>
        bookings.filter((booking) => moment(booking.createdAt).format("MMM YYYY") === month).length
    );
  } else if (value === "Today") {
    // Generate hourly intervals for the last 24 hours
    categories = Array.from({ length: 24 }, (_, i) =>
      now.clone().startOf("day").add(i, "hours").format("ha")
    );

    seriesData = categories.map((hour) => {
      return bookings.filter((booking) => moment(booking.createdAt).format("ha") === hour).length;
    });
  } else if (value === "Last 7 days") {
    categories = Array.from({ length: 7 }, (_, i) =>
      now.clone().subtract(i, "days").format("DD MMM")
    ).reverse();
    seriesData = categories.map(
      (date) =>
        bookings.filter((booking) => moment(booking.createdAt).format("DD MMM") === date).length
    );
  } else if (value === "Last 30 days") {
    categories = Array.from({ length: 30 }, (_, i) =>
      now.clone().subtract(i, "days").format("DD MMM")
    ).reverse();
    seriesData = categories.map(
      (date) =>
        bookings.filter((booking) => moment(booking.createdAt).format("DD MMM") === date).length
    );
  }

  return { categories, seriesData };
};

const BookingChart = ({ bookingsData, value }) => {
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    const filteredBookings = filterBookingsByTimeframe(bookingsData, value);
    const { categories, seriesData } = getBookingChartData(filteredBookings, value);

    setChartOptions({
      chart: {
        type: "line",
        backgroundColor: "#fff",
        borderRadius: 10,
        height: 250,
        style: {
          fontFamily: "'Arial', sans-serif",
        },
        plotBorderColor: "#606063",
      },
      title: {
        text: "",
        style: {
          color: "#333",
          fontWeight: "bold",
          fontSize: "18px",
        },
      },
      xAxis: {
        categories,
        labels: {
          style: {
            color: "#474747",
            fontSize: "10px",
          },
        },
        lineColor: "#D7E4EB",
        lineWidth: 1,
        tickColor: "#333",
        gridLineColor: "#e6e6e6",
        gridLineDashStyle: "dot",
        gridLineWidth: 1.5,
      },
      yAxis: {
        title: {
          text: "",
          style: {
            color: "#d1d1cf",
            fontSize: "10px",
          },
        },
        labels: {
          style: {
            color: "#474747",
            fontSize: "12px",
          },
        },
        gridLineColor: "#fff",
      },
      series: [
        {
          name: "Bookings",
          data: seriesData.length ? seriesData : [0], // Display 0 if no data
          color: "#E09338",
          lineWidth: 1.2,
          marker: {
            enabled: false,
          },
        },
      ],
      tooltip: {
        shared: true,
        crosshairs: true,
        formatter: function () {
          return `${this.points[0].key}<br/>${this.points[0].series.name}: ${this.points[0].y} Bookings`;
        },
        backgroundColor: "rgba(255, 255, 255, 0.85)",
        borderColor: "#ccc",
        style: {
          color: "#333",
          fontSize: "12px",
        },
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
    });
  }, [bookingsData, value]);

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
};

export default BookingChart;
